import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { CryptoDataService } from 'app/core/services/crypto.data.service';
import { AuthenticationProperties, AuthenticationTypes } from 'app/security/core/enums/authentication-types.enum';
import { IAuthenticationMethod } from 'app/security/core/typings/IAuthentication';

@Component({
  selector: 'security-auth-detail',
  templateUrl: './security-auth-detail.component.html',
  styleUrls: ['./security-auth-detail.component.scss']
})
export class SecurityAuthDetailComponent implements OnChanges {
  currentAllowedExtensions: string;
  currentFileName: string;
  originalFileName: string;
  
  private originalValue: any;
  
  @Input() isDisabled: boolean = false;
  @Input() selectItem: any;
  @Input() selectedMetadata: any;
  @Input() selectedMethod: IAuthenticationMethod;
  @Input() templateToShow: any;
  @Input() selectedMultipleAuthenticator: any;
  
  @Output() pendingChanges = new EventEmitter<boolean>();
  @Output() updateItem = new EventEmitter<{item: any, fileName: string}>();
  @Output() currentFileNameEmit = new EventEmitter<string>();

  @ViewChild('fileUploaded', { static: false}) fileUploaded;

  constructor(private _cryptoDataService: CryptoDataService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectItem'] && this.selectItem) {
      this.originalValue = this.selectItem.value;
      this.pendingChanges.emit(false);
      this.getFileName();
    }
  }

  onValueChange(): void {
    const hasChanges = this.selectItem?.value !== this.originalValue || this.currentFileName !== this.originalFileName;

    this.pendingChanges.emit(hasChanges);
    this.currentFileNameEmit.emit(this.currentFileName);
  }

  setCurrentBooleanValue(value: boolean) {
    this.selectItem.value = value ? 'True' : 'False';
    this.onValueChange();
  }

  getFileName() {
    if (this.selectItem && this.selectedMetadata && 
      this.selectedMetadata[(this.selectItem.key || this.selectItem.name)].type === 'file') {
      const name = this.selectedMetadata[(this.selectItem.key || this.selectItem.name)].name;
      const selectedMethod = this.selectedMethod.type === AuthenticationTypes.MULTIPLE && this.selectedMultipleAuthenticator ? this.selectedMultipleAuthenticator : this.selectedMethod;
      this.originalFileName = selectedMethod[AuthenticationProperties.OPTIONS][name];
      this.currentFileName = this.originalFileName;
      this.currentAllowedExtensions = this._getExtensions(this.selectedMetadata[(this.selectItem.key || this.selectItem.name)].extensions);
    }
  }

  uploadFile() {
    this.fileUploaded.nativeElement.click();
  }

  readFile(input) {
    const file: File = input.files[0];

    if (file) {
      const splittedName: Array<string> = file.name.split('.');
      const extension: string = splittedName[splittedName.length - 1];

      if (this.currentAllowedExtensions.includes(extension)) {
        const fileReader: FileReader = new FileReader();

        fileReader.onloadend = e => {
          const fileContentParts = (fileReader.result as string).split(',');
          this.selectItem.value =
            fileContentParts.length === 1
              ? fileContentParts[0]
              : fileContentParts[1];
          this.currentFileName = file.name;
          this.onValueChange();
        };
        fileReader.readAsDataURL(file);
      }
    }
  }

  isFormValid() {
    let isValid = true;
    if (this.selectedMetadata[(this.selectItem.key || this.selectItem.name)].type === 'number')
      isValid = ( Number(this.selectItem.value) >= this.selectedMetadata[(this.selectItem.key || this.selectItem.name)].min &&
        Number(this.selectItem.value) <= this.selectedMetadata[(this.selectItem.key || this.selectItem.name)].max);
    return isValid;
  };

  async encryptPassword() {
    if(this.selectedMetadata[(this.selectItem.key || this.selectItem.name)].type === 'password') {
      this.selectItem.value = await this._cryptoDataService.encryptStringPromise(this.selectItem.value);
    }
  }

  async updateData() {
    await this.encryptPassword();
    this.updateItem.emit({
      item: this.selectItem,
      fileName: this.currentFileName
    });
    
    // After saving, update the original value and reset pending changes
    this.originalValue = this.selectItem.value;
    this.pendingChanges.emit(false);
  }

  private _getExtensions(extensions: Array<string>) {
    let extensionsString = '*';

    if (extensions) {
      const mappedExtensions = extensions.map(extension => {
        return '.' + extension;
      });
      extensionsString = mappedExtensions.join();
    }

    return extensionsString;
  }
}
